var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer",staticStyle:{"margin-top":"46px","width":"100%","text-align":"center"}},[_c('span',{staticStyle:{"display":"block","font-size":"12px","margin-top":"0.8rem","color":"#7d90b2","letter-spacing":"0","text-align":"center","line-height":"12px"}},[_vm._v(_vm._s(_vm.$t("login.copyright")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }